import gql from 'graphql-tag';

export class ThresholdQueries {
  static EvaluateActiveDocumentThreshold = gql`
    query evaluateActiveDocumentThreshold($documentId: String!) {
      evaluateActiveDocumentThreshold(documentId: $documentId) {
        hasReachedThreshold
        threshold {
          documentThreshold
          documentCount
        }
      }
    }
  `;
  static GetActiveDocumentThreshold = gql`
    query getActiveDocumentThreshold {
      activeDocumentThreshold {
        documentThreshold
        documentCount
      }
    }
  `;
}
